import React, { useState, useEffect } from 'react';
import QRCodeGenerator from './QRCodeGenerator';
import { deleteQrLabelCall } from 'features/qrLabel/deleteQrLabel';
import { updateQrLabelCall } from 'features/qrLabel/updateQrLabel';
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from 'react-i18next';
import { createQrLabelCall } from 'features/qrLabel/createQrLabel';
import { FaPlus } from 'react-icons/fa';

import i18n from 'i18n';

const DatalistAltCS = ({ data, num, add, det}) => {
    const dispatch = useDispatch();
    const { qr_account, qr_label_list_load, language } = useSelector(state => state.user);
    const [selectedRow, setSelectedRow] = useState(null);
    const [editData, setEditData] = useState({});
    const { t } = useTranslation();
    const t_eng = i18n.getFixedT('en');
    const t_hrv = i18n.getFixedT('hr');
    const [lan, setLan] = useState("hr");
    const [listToShowHr, setListToShowHr] = useState([]);
    const [listToShowEn, setListToShowEn] = useState([]);
    const [listToShowSk, setListToShowSk] = useState([]);
    const [listToShowSv, setListToShowSv] = useState([]);
    const [listToShowCs, setListToShowCs] = useState([]);
    const [listToShow, setListToShow] = useState([]);
    const [num_local, setNum_local] = useState(0);

    useEffect(() => {
        if (num) {
            setNum_local(num);
        }
        
    }, [dispatch, num]);

    useEffect(() => {
        if (data) {
            const groupedHr = data.filter(item => item.lang === 'hr');
            const groupedEn = data.filter(item => item.lang === 'en');
            const groupedSk = data.filter(item => item.lang === 'sk');
            const groupedSv = data.filter(item => item.lang === 'sv');
            const groupedCz = data.filter(item => item.lang === 'cs');

            const hrMap = new Map(groupedHr.map(item => [item.masked_id, item]));
            const enMap = new Map(groupedEn.map(item => [item.masked_id, item]));
            const skMap = new Map(groupedSk.map(item => [item.masked_id, item]));
            const svMap = new Map(groupedSv.map(item => [item.masked_id, item]));
            const czMap = new Map(groupedCz.map(item => [item.masked_id, item]));

            hrMap.forEach((hrItem, masked_id) => {
                if (!enMap.has(masked_id)) {
                    groupedEn.push({ ...hrItem});
                }
            });

            setListToShowHr(groupedHr);
            setListToShowEn(groupedEn);
            setListToShowSk(groupedSk);
            setListToShowSv(groupedSv);
            setListToShowCs(groupedCz);
        }
    }, [dispatch, data]);

    useEffect(() => {
        if (lan === 'hr') {
            setListToShow(listToShowHr);
        } else {
            setListToShow(listToShowEn);
        }
    }, [dispatch, lan, listToShowHr, listToShowEn]);

    const handleEdit = (item) => {
        setSelectedRow(item.id);
        setEditData({ ...item });
    };

    const onChange = e => {
        setEditData({ ...editData, [e.target.name]: e.target.value });
    };

    const saveChanges = () => {
        const payload = { ...editData };
        dispatch(updateQrLabelCall(payload));
        setSelectedRow(null);
    };

    const cancelEdit = () => {
        setSelectedRow(null);
    };

    const handleDelete = (id) => {
        const payload = { id: id };
        dispatch(deleteQrLabelCall(payload));
        setSelectedRow(null);
    };

    const changeLanguageHc = (lng) => {
        setLan(lng);
    };

    const createNewEntry = (entry) => {
        const { id, ...rest } = entry;
        const payload = { ...rest, lang: lan };
        dispatch(createQrLabelCall(payload));
    };

    function truncateText(text, maxLength) {
        if (text.length <= maxLength) {
            return text;
        }
        return text.substring(0, maxLength) + '...';
    }

    function truncateText2(text, maxLength) {
        if (text.length <= maxLength) {
            return text;
        }
        return text.substring(0, maxLength);
    }

    function retLangOrEn(hr, en, sk, sv, cz) {
        let ret = en;

        if(language === "hr" && hr.length > 0){
            ret = hr;
        }

        if(language === "sk" && sk.length > 0){
            ret = sk;
        }

        if(language === "sv" && sv.length > 0){
            ret = sv;
        }

        if(language === "cs" && cz.length > 0){
            ret = cz;
        }

        return ret;
    };

    if (qr_label_list_load) {
        return (
            <div className="card" style={{ width: "100%", padding: "20px" }}>
                <div className="spinner-border text-primary mt-4" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    const totalCards = Math.max(num_local, listToShow.length);
    const placeholders = Array(totalCards - listToShow.length).fill({});

    return (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px', justifyContent: 'center' }}>
            {listToShow.map(group => {
                const hrEntry = listToShowHr.find(item => item.masked_id === group.masked_id);
                const enEntry = listToShowEn.find(item => item.masked_id === group.masked_id);
                const skEntry = listToShowSk.find(item => item.masked_id === group.masked_id);
                const svEntry = listToShowSv.find(item => item.masked_id === group.masked_id);
                const csEntry = listToShowCs.find(item => item.masked_id === group.masked_id);
                

                if(!hrEntry || !enEntry || !skEntry || !svEntry || !csEntry)
                    return(<></>);

                return (
                <QRCodeGenerator maskedId={hrEntry?.masked_id || group.masked_id} name={truncateText2(retLangOrEn(hrEntry.name, enEntry.name, skEntry.name, svEntry.name, csEntry.name), 50)} itemid={hrEntry?.id || group.id} det={det}/> 
                );
            })}
{placeholders.map((_, index) => {
    const slotNumber = listToShow.length + index + 1;
    return (
        <div
            key={`placeholder-${index}`}
            style={{
                width: '300px',
                height: '478px',
                border: '2px dashed #b8e6c3',
                borderRadius: '14px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: 'rgba(230, 255, 242, 0.3)',
                transition: 'background-color 0.2s',
            }}
            onMouseEnter={e => e.currentTarget.style.backgroundColor = 'rgba(230, 255, 242, 0.6)'}
            onMouseLeave={e => e.currentTarget.style.backgroundColor = 'rgba(230, 255, 242, 0.3)'}
        >
            <div style={{ textAlign: 'center', color: '#2e7d32' }}>
                <span style={{
                    fontSize: '24px',
                    fontWeight: 600,
                    display: 'block',
                    marginBottom: '16px',
                    opacity: 0.6,
                }}>
                    {slotNumber}
                </span>
                <button className="btn-icon-mint"
                    onClick={(e) => {
                        e.stopPropagation();
                        add();
                    }}
                    style={{
                        background: 'transparent',
                        border: '1px solid #2e7d32',
                        color: '#2e7d32',
                        borderRadius: '6px',
                        padding: '8px 20px',
                        fontSize: '14px',
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '6px',
                        cursor: 'pointer',
                    }}
                >
                    <FaPlus style={{ fontSize: '16px' }} />
                    {t('add')}
                </button>
            </div>
        </div>
    );
})}
        </div>
    );
};

export default DatalistAltCS;
